import React from 'react'
import { GridContextProvider, GridDropZone, GridItem, swap } from 'react-grid-dnd'
import Icon from '../shared/icon'
import { renumberPositions } from './catalogueOrdering'
import { useCatalogue } from './CatalogueProvider'
import { CategoryNode } from './catalogueTypes'
import { t } from '../../i18n'

const BOXES_PER_ROW = 3
const ROW_HEIGHT = 250

const CategoryImage = ({ category }: { category: CategoryNode }) => (
  <div className="robis-image">
    {category.file_url ? (
      <img src={category.file_url} />
    ) : (
      <div>
        <i className="bi bi-card-image"></i>
      </div>
    )}
  </div>
)

const CategoryCard = ({ category }: { category: CategoryNode }) => {
  const { meta } = useCatalogue()

  return (
    <div id={`category-${category.id}`} className="card robis-image-card ms-4 p-0" onClick={() => meta.go.category(category.id)}>
      <CategoryImage category={category} />
      <div className="card-body robis-card-body">
        <b>{category.name}</b>
      </div>
    </div>
  )
}

const EditableCategoryCard = ({ category }: { category: CategoryNode }) => {
  const { meta } = useCatalogue()

  const openEdit = (event: React.MouseEvent) => {
    event.preventDefault()
    event.stopPropagation()
    meta.go.edit(category)
  }

  return (
    <div id={`category-${category.id}`} className="card robis-image-card ms-4 p-0">
      <CategoryImage category={category} />
      <div className="card-body robis-card-body">
        <b>{category.name}</b>
      </div>
      <div className="overlay text-center">
        <Icon name="dragCross" className="drag-icon cross-icon" />
        <div className="mb-1">{t('catalogue.drag_to_reposition')}</div>
        {meta.canManageCategories && (
          <div className="d-flex justify-content-center" onClick={openEdit}>
            <Icon name="editIcon" className="primary-edit-icon me-2" />
            <span className="as-link white">{t('global.edit')}</span>
          </div>
        )}
      </div>
    </div>
  )
}

const RootCategoryGrid = () => {
  const { state, actions } = useCatalogue()
  const { roots, editMode } = state

  const handleChange = (_sourceId: string, sourceIndex: number, targetIndex: number) =>
    actions.reorderRoots(renumberPositions(swap(roots, sourceIndex, targetIndex)))

  return (
    <GridContextProvider onChange={handleChange}>
      <GridDropZone
        id="items"
        boxesPerRow={BOXES_PER_ROW}
        rowHeight={ROW_HEIGHT}
        disableDrag={!editMode}
        className="category-grid-drop-zone"
      >
        {roots.map((category) => (
          <GridItem key={category.id} className="grid-robis-card">
            {editMode ? <EditableCategoryCard category={category} /> : <CategoryCard category={category} />}
          </GridItem>
        ))}
      </GridDropZone>
    </GridContextProvider>
  )
}

export default RootCategoryGrid
